import FormControl from '@mui/material/FormControl';
import styled from 'styled-components';
import Select from '../../Select';

export const InputContainer = styled.div`
  margin-left: 4px;
`;

export const StyledFormControl = styled(FormControl)`
  margin-top: 26px;
  .MuiTextField-root {
    margin-top: 10px;
    width: 100%;
    .MuiInputBase-root {
      padding: 5px 8px;
    }
    .MuiInputBase-formControl {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }
  .AssetFieldSelect--is-disabled {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .AssetFieldSelect__control {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .MuiInputBase-inputAdornedEnd {
    padding-left: 5px !important;
  }
  .AssetFieldSelect__single-value {
    overflow: visible;
  }
`;

export const StyledSelect = styled(Select)`
  margin-top: 5px;
`;

const dropDownColorHover = 'rgba(218, 23, 23, 0.3)';
const dropDownColorActive = 'rgba(218, 23, 23, 0.5)';
const dropDownColorSelected = 'rgb(218, 23, 23)';

export const DropdownOptionContainer = styled.div`
  .AssetFieldSelect__option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 32px;
    align-items: center;
    &:hover {
      background-color: ${dropDownColorHover};
    }
    &:active {
      background-color: ${dropDownColorActive};
    }
  }
  .AssetFieldSelect__option--is-focused {
    background-color: ${dropDownColorHover};
  }
  .AssetFieldSelect__option--is-selected {
    background-color: ${dropDownColorSelected};
    color: white;
    &:hover {
      background-color: ${dropDownColorSelected};
    }
    .buttons .MuiButtonBase-root {
      color: white;
    }
  }
  .buttons {
    display: none;
  }
  .AssetFieldSelect__option:hover .buttons {
    display: block;
  }
`;

export const AttachmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  .attachment {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .attachment-name {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .MuiChip-root {
      margin-left: 8px;
      background-color: rgb(218, 23, 23);;
      color: white;
    }
    .label {
      font-size: 12px;  
    }
    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
  &.disabled {
    margin-top: 8px;
    .attachment {
      padding: 4px 0;
    }
    .label {
      color:rgb(153, 153, 153);
    }
  }
`;

export const Spacer = styled.div`
  display: block;
  height: 28px;
`;

export const DropContainer = styled.div`
  margin: 10px 5px 0 5px;
  flex-shrink: 1;
  display: flex;
  align-items: center;
  border: 1px dashed #ff6550;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  section {
    width: 100%;
    & > div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      span {
        padding: 0 10px;
        line-height: 18px;
      }
    }
  }
`;
